export default process.env.REACT_APP_PLATFORM_NAME;
